import React from 'react';
import { Info, Phone, Navigation, FileText, Camera, ListChecks, Package } from 'lucide-react';

export function OrderActions({
  order,
  hasNote,
  hasImages,
  hasStatus,
  hasPackagesToScan, // NEW PROP
  onInfoClick,
  onContactClick,
  onDirectionsClick,
  onNoteClick,
  onCameraClick,
  onStatusClick,
  onScanClick // NEW PROP
}) {
  return (
    <div className="absolute bottom-24 right-4 flex flex-col gap-2 z-10">
      {/* Scan Packages Button - Only show if has packages */}
      {hasPackagesToScan && (
        <button
          onClick={onScanClick}
          className="w-14 h-14 bg-brand-gold hover:bg-brand-gold/90 text-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110"
          title="Escanear paquetes"
        >
          <Package className="w-6 h-6" />
        </button>
      )}

      {/* Info Button */}
      <button
        onClick={onInfoClick}
        className="w-14 h-14 bg-white hover:bg-gray-50 text-gray-700 rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110"
        title="Información del recojo"
      >
        <Info className="w-6 h-6" />
      </button>

      {/* Contact Button */}
      <button
        onClick={onContactClick}
        className="w-14 h-14 bg-white hover:bg-gray-50 text-gray-700 rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110"
        title="Contactar"
      >
        <Phone className="w-6 h-6" />
      </button>

      {/* Directions Button */}
      <button
        onClick={onDirectionsClick}
        className="w-14 h-14 bg-brand-primary hover:bg-brand-primary/90 text-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110"
        title="Direcciones"
      >
        <Navigation className="w-6 h-6" />
      </button>

      {/* Note Button */}
      <button
        onClick={onNoteClick}
        className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110 ${
          hasNote
            ? 'bg-brand-green text-white'
            : 'bg-white hover:bg-gray-50 text-gray-700'
        }`}
        title="Nota del conductor"
      >
        <FileText className="w-6 h-6" />
      </button>

      {/* Camera Button */}
      <button
        onClick={onCameraClick}
        className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110 ${
          hasImages
            ? 'bg-brand-green text-white'
            : 'bg-white hover:bg-gray-50 text-gray-700'
        }`}
        title="Agregar fotos"
      >
        <Camera className="w-6 h-6" />
      </button>

      {/* Status Button */}
      <button
        onClick={onStatusClick}
        className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110 ${
          hasStatus
            ? 'bg-brand-green text-white'
            : 'bg-white hover:bg-gray-50 text-gray-700'
        }`}
        title="Estado del recojo"
      >
        <ListChecks className="w-6 h-6" />
      </button>
    </div>
  );
}